export default __webpack_public_path__ + "open-wrench-tool-silhouette.png";